module.exports = __webpack_public_path__ + "3910b7cf84aea04f1e01702902fd336b.png";